var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecondarySmall = function SvgSecondarySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 188 189"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD513",
    d: "M174.889 108.563c0 45.762-63.209 62.667-108.97 62.667C20.156 171.23 13 119.51 13 73.748S72.379 17 118.141 17s56.748 45.801 56.748 91.563"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#secondary-small_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#secondary-small_svg__b)",
    fillOpacity: 0.3,
    d: "M1.431 46.935C31.425 31.505 88.444.692 88.444.692c.719.94 1.377 1.851 1.987 2.733.218.314.272 1.255.272 1.255s.745.249.93.53c.576.88 1.11 1.728 1.618 2.543.14.226-.716 1.629-.716 1.629s1.393-.537 1.521-.33c2.25 3.636 4.099 6.57 7.079 8.799l5.465 8.79C60.085 52.021 9.045 76.242 9.045 76.242c.767-6.5-2.151-3.397-2.968-8.263-.055-.327.593-1.179.53-1.54-.067-.377-.833-.474-.905-1.229-.19-1.99-.472-5.01-1.228-7.57-.101-.346.301-1.134.301-1.134l-.89-.876-.778-2.682.113-2.162-1.149-1.532z",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#secondary-small_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#secondary-small_svg__d)",
    fillOpacity: 0.3,
    d: "M181.095 143.459c-30.586 14.218-88.79 42.73-88.79 42.73a72 72 0 0 1-1.877-2.811c-.204-.322-.22-1.264-.22-1.264s-.736-.279-.909-.567c-.54-.903-1.04-1.771-1.516-2.606-.131-.232.781-1.599.781-1.599s-1.413.481-1.533.269c-2.104-3.723-3.833-6.728-6.722-9.075l-5.109-9.001c47.492-23.501 99.458-45.665 99.458-45.665-1.025 6.465 2.014 3.481 2.636 8.376.042.328-.64 1.154-.591 1.517.051.38.813.507.855 1.264.11 1.996.272 5.025.924 7.614.088.349-.346 1.121-.346 1.121l.855.911.67 2.71-.2 2.155 1.087 1.577z",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "secondary-small_svg__b",
    x1: 4.141,
    x2: 96.582,
    y1: 68.399,
    y2: 14.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "secondary-small_svg__d",
    x1: 179.245,
    x2: 84.742,
    y1: 121.903,
    y2: 171.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "secondary-small_svg__a",
    width: 107.168,
    height: 78.551,
    x: 0.431,
    y: 0.692,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_976_59875"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_976_59875",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_976_59875"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "secondary-small_svg__c",
    width: 107.895,
    height: 75.319,
    x: 74.2,
    y: 113.87,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_976_59875"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_976_59875",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_976_59875"
  })))));
};
export default SvgSecondarySmall;